import React from 'react';
import styles from './styles.module.css';

import LoadingIndicator from '../../../loading-indicator';

export default ({ closeForm, secondaryButtonIsBack, clearForm }) => (
  <div id="form-submitting" className={styles.container}>
    <LoadingIndicator />
    <p>Sending your submission</p>
    <p>Please wait...</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/state-pages/submitting/index.js